<template>
  <div>
    <LessonHeader
      :enable-theme="false"
      :hide-display="'hide_center'"
      :trial-lesson="true"
      :logout="trialLessonLoginSuccess"
    />

    <Login v-if="!trialLessonLoginSuccess" />
    <LessonList v-else />

    <BottomMenu :hide-display="'left_center'" :trial-lesson="true" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import LessonHeader from '@/components/Lesson/Header/LessonHeader';
import BottomMenu from '@/components/Lesson/Footer/BottomMenu';
import Login from '@/components/TrialLesson/index';
import LessonList from '@/components/TrialLesson/LessonList';

export default {
  components: {
    LessonHeader,
    BottomMenu,
    Login,
    LessonList
  },
  computed: {
    ...mapState('triallesson',['trialLessonLoginSuccess'])
  },
  beforeMount() {
    this.$i18n.locale = 'ja';
  },
};
</script>
